<ion-select fill="outline"
            [label]="label"
            labelPlacement="stacked"
            [formControl]="control"
            mode="md">
    <ion-select-option *ngFor="let opt of options"
                       [value]="opt.key">{{opt.label}}</ion-select-option>
</ion-select>
